import { post, request } from '../api';

/** Mirrors `apps/api/src/mcp/oauth.controller.ts`: the consent page and the Profile's connected-assistants block. */

export interface ConsentInfo {
  client: { id: string; name: string };
}

export interface ConsentRequest {
  clientId: string;
  redirectUri: string;
  codeChallenge: string;
  scope: string[];
  state?: string;
  resource?: string;
}

export interface GrantView {
  id: string;
  client: { id: string; name: string };
  scopes: string[];
  createdAt: string;
  lastUsedAt: string;
  expiresAt: string | null;
}

export const connectApi = {
  consentInfo: (clientId: string) => request<ConsentInfo | { error: 'invalid_client' }>(`/oauth/consent?client_id=${encodeURIComponent(clientId)}`),
  consent: (body: ConsentRequest) => post<{ redirectTo: string }>('/oauth/consent', body),
  deny: (body: { redirectUri: string; state?: string }) => post<{ redirectTo: string }>('/oauth/deny', body),
  grants: () => request<GrantView[]>('/oauth/grants'),
  revokeGrant: (id: string) => request<GrantView[]>(`/oauth/grants/${encodeURIComponent(id)}`, { method: 'DELETE' }),
};
